import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBathMan1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bath-man-1, man, male"><path d="M12 1C10.3431 1 9 2.34315 9 4C9 5.65685 10.3431 7 12 7C13.6569 7 15 5.65685 15 4C15 2.34315 13.6569 1 12 1Z" fill="currentColor"/><path d="M6.75 8C6.33579 8 6 8.33579 6 8.75V16.25C6 16.6642 6.33579 17 6.75 17H8V22.25C8 22.6642 8.33579 23 8.75 23H15.25C15.6642 23 16 22.6642 16 22.25V17H17.25C17.6642 17 18 16.6642 18 16.25V8.75C18 8.33579 17.6642 8 17.25 8H6.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBathMan1;
